import { Box, FormLabel } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const Paper = styled(Box)`
    & > * > * > * > label {
        font-weight: thin;
    }

    & > * > * > label {
        font-weight: thin;
    }

    & > * > label { 
        font-weight: thin;
    }
`;
